<template>
  <div class="animated fadeIn step-container direct-payment">
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <h2 class="text-center">ชำระค่าบริการ</h2>
      </div>
      <div class="col-md-8 offset-md-2 step-body">
        <h4 class="step-header">รายละเอียดบริการ</h4>
        <div class="row">
          <div class="col-12">
            <table class="table summary-table">
              <thead>
                <tr>
                  <th>Detail</th>
                  <th>ระยะเวลา</th>
                  <th>ราคา</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <p>
                      <strong>{{selectedPlan.name}} </strong>
                      <br> 
                      {{selectedPlan.detail}}
                    </p>
                  </td>
                  <td>{{selectedPlan.duration}}</td>
                  <td>฿{{selectedPlan.price | formatNumber}}</td>
                </tr>
                <tr>
                  <td></td>
                  <td>รวมทั้งหมด</td>
                  <td>฿{{selectedPlan.price | formatNumber}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <h4 class="text-center direct-detail-title">ชำระค่าบริการโดยการโอนเงินที่บัญชี</h4>
          </div>
          <div class="col-12 text-center">
            <div class="direct-detail">
              <img class="bank-logo" src="/static/img/kbank.png">
              <div class="bank-detail">
                <p class="bank-name">ธนาคารกสิกรไทย (K-BANK)</p>
                <p class="account-number">เลขที่บัญชี: 008-1-22010-7</p>
                <p class="account-name">ชื่อบัญชี: บจก. ซีคด็อก</p>
              </div>
            </div>
          </div>
          <div class="col-12 text-center inform-transfer">
            <p>จำนวนเงิน ฿{{selectedPlan.price | formatNumber}}</p>
            <div class="btn btn-success">แจ้งการชำระแล้วเงินที่ Email: zeekdoc@yahoo.com หรือ โทร 092-462-6633 (ฟ้า)</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  data () {
    return {
      selectedPlan: {},
      doctorPlans: [
        {
          id: 1,
          name: 'Basic Plan (subscription)',
          detail: '499 (per month) x 3 months',
          duration: '3 เดือน',
          price: 1497
        },
        {
          id: 2,
          name: 'Advance Plan (subscription)',
          detail: '฿399 (per month) x 12 months',
          duration: '1 ปี',
          price: 4788
        },
        {
          id: 3,
          name: 'Pro Plan (subscription)',
          detail: '฿299 (per month) x 36 months',
          duration: '3 ปี',
          price: 10764
        }
      ],
      clinicPlans: [
        {
          id: 1,
          name: 'Basic Plan (subscription)',
          detail: '1,500 (per month) x 3 months',
          duration: '3 เดือน',
          price: 4500
        },
        {
          id: 2,
          name: 'Advance Plan (subscription)',
          detail: '1,333 (per month) x 12 months',
          duration: '1 ปี',
          price: 16000
        },
        {
          id: 3,
          name: 'Pro Plan (subscription)',
          detail: '฿1,250 (per month) x 36 months',
          duration: '3 ปี',
          price: 45000
        }
      ]
    }
  },
  mounted () {
    if (this.$route.query.type === 'doctor' && this.$route.query.plan_id !== undefined) {
      this.selectedPlan = this.doctorPlans[parseInt(this.$route.query.plan_id) - 1]
    } else if (this.$route.query.type === 'clinic' && this.$route.query.plan_id !== undefined) {
      this.selectedPlan = this.clinicPlans[parseInt(this.$route.query.plan_id) - 1]
    }
  }
}
</script>
<style lang='scss'>
.step-body{
  background-color: #fff;
  padding: 20px;
}
.direct-payment{
  .summary-table{
    border: solid 1px #d0d9dd;
  }
  .bank-logo{
    width: 100px;
  }
  .direct-detail-title{
    padding: 20px 0 10px;
  }
  .inform-transfer{
    padding: 30px 0 10px;
    p{
      font-size: 20px;
      font-weight: bold;
    }
  }
  .direct-detail{
    display: inline-block;
    
    .bank-logo{
      vertical-align: middle;
    }
    .bank-detail{
      display: inline-block;
      vertical-align: middle;
      padding: 10px;
      p{
        margin-bottom: 0px;
        font-size: 16px;
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// direct.vue?457f6df3